/**
 * @generated SignedSource<<1a442c7b9b512a79d293c676b48cdd86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNftProfileOwner_viewer$data = {
  readonly loggedInUser?: {
    readonly canImport: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"usePersistedWalletAddress_viewer">;
  readonly " $fragmentType": "useNftProfileOwner_viewer";
};
export type useNftProfileOwner_viewer$key = {
  readonly " $data"?: useNftProfileOwner_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNftProfileOwner_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "loggedInUserId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchUser"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "loggedInUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./useNftProfileOwnerRefetchQuery.graphql')
    }
  },
  "name": "useNftProfileOwner_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchUser",
          "variableName": "fetchUser"
        },
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "usePersistedWalletAddress_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "loggedInUser",
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": "canImport",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "NFT_IMPORT_CONTRACT_SELF_SERVE"
                }
              ],
              "kind": "ScalarField",
              "name": "hasPermission",
              "storageKey": "hasPermission(name:\"NFT_IMPORT_CONTRACT_SELF_SERVE\")"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "fa41e893c4f21bd386bab44404c739d5";

export default node;
